import Vue from 'vue'
import {
    Button,
    DatePicker,
    Upload,
    Dialog,
    Input,
    MessageBox,
    Message,
    Pagination,
    Switch,
    Popover,
    Slider,
    Radio,
    RadioGroup,
    Carousel,
    CarouselItem,
    Drawer,
    Card,
    Container,
    Header,
    Main,
    Aside,
    Table,
    TableColumn,
    Divider,

} from 'element-ui'

Vue.use(Button)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(DatePicker)
Vue.use(Upload)
Vue.use(Dialog)
Vue.use(Input)
Vue.use(Pagination)
Vue.use(Switch)
Vue.use(Popover)
Vue.use(Slider)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Drawer)

Vue.use(Card)
Vue.use(Container)
Vue.use(Header)
Vue.use(Main)
Vue.use(Aside)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Divider)


Vue.prototype.$MessageBox = MessageBox;
Vue.prototype.$message = Message;